module.exports = __webpack_public_path__ + "static/img/4111240.8c645bd.svg";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/4111240.svg
// module id = pvs3
// module chunks = 0